export default __webpack_public_path__ + "static/media/fullscreen.3b1e196e.svg";